import React, { FC, useEffect } from 'react';
import { fetchNotificationCenter } from '@src/redux/actions/notificationCenter';
import apolloClient from '@src/graphql/apollo';
import { NotificationCenterUpdatedDocument } from '@src/graphql/generated';
import { useAppDispatch } from '@src/redux';
import { SubscriptionsProps } from './props';

export const Subscriptions: FC<SubscriptionsProps> = ({ children }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const notificationCenterUpdatedSubscription = apolloClient
      .subscribe({ query: NotificationCenterUpdatedDocument })
      .subscribe(dispatch(fetchNotificationCenter()));

    return () => {
      notificationCenterUpdatedSubscription.unsubscribe();
    };
  }, []);

  return <>{children}</>;
};
